import React from 'react';
import { SvgIcon } from 'material-ui';

const ExitBtnIcon = props => (
  <SvgIcon {...props} width='18' height='18' viewBox='0 0 18 18'>
    <path
      d='M10.0681111,7.58464284 L19.5681111,7.58464284 C20.1203959,7.58464284 20.5681111,8.03235809 20.5681111,8.58464284 C20.5681111,9.13692759 20.1203959,9.58464284 19.5681111,9.58464284 L10.0681111,9.58464284 L10.0681111,19.0846428 C10.0681111,19.6369276 9.62039588,20.0846428 9.06811113,20.0846428 C8.51582638,20.0846428 8.06811113,19.6369276 8.06811113,19.0846428 L8.06811113,9.58464284 L-1.43188887,9.58464284 C-1.98417362,9.58464284 -2.43188887,9.13692759 -2.43188887,8.58464284 C-2.43188887,8.03235809 -1.98417362,7.58464284 -1.43188887,7.58464284 L8.06811113,7.58464284 L8.06811113,-1.91535716 C8.06811113,-2.46764191 8.51582638,-2.91535716 9.06811113,-2.91535716 C9.62039588,-2.91535716 10.0681111,-2.46764191 10.0681111,-1.91535716 L10.0681111,7.58464284 Z'
      id='Combined-Shape'
      fill='#D8D8D8'
      fillRule='nonzero'
      transform='translate(9.068111, 8.584643) rotate(-315.000000) translate(-9.068111, -8.584643) '
    />
  </SvgIcon>
);

export default ExitBtnIcon;



// WEBPACK FOOTER //
// ./src/icons/ExitBtnIcon.js